import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const KEY = "sc_pending_captures";

export interface PendingCapture {
  client_id: string;
  endpoint: string;
  payload: any;
  storeDayId: string;
  label: string;
  createdAt: string;
}

export function loadPending(): PendingCapture[] {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
}
function save(list: PendingCapture[]) { localStorage.setItem(KEY, JSON.stringify(list)); }
export function addPending(p: PendingCapture) { const l = loadPending(); l.push(p); save(l); }
export function removePending(clientId: string) { save(loadPending().filter((x) => x.client_id !== clientId)); }
export function pendingForDay(dayId: string): PendingCapture[] { return loadPending().filter((x) => x.storeDayId === dayId); }

// Resend queued captures. Idempotent server-side via client_id, so retries never duplicate.
export async function syncPending(): Promise<number> {
  const list = loadPending();
  let synced = 0;
  for (const p of list) {
    try {
      await api.post(p.endpoint, p.payload);
      removePending(p.client_id);
      synced++;
    } catch (e: any) {
      if (e?.response) { removePending(p.client_id); } // server rejected: drop to avoid a poison-loop
      // otherwise still offline -> keep for next attempt
    }
  }
  return synced;
}

export function genClientId(): string {
  return "cap_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
}

export function useOnline(): boolean {
  const [online, setOnline] = useState(typeof navigator !== "undefined" ? navigator.onLine : true);
  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", off); };
  }, []);
  return online;
}
